import FilteringToggle from './FilteringToggle'

export default class {
  constructor() {
    
    const domFiltering = document.querySelectorAll('[data-js="filtering"]');
    if (domFiltering) {
      [...domFiltering].forEach(el => {
        new FilteringToggle(el);
      });
    }

  }
}
